export interface UpdateDefaultParameterInterLibraryLoanRequest {
  id: string
  materialFormatCode: string
  holdingBranchCode: string
  collectionType: string
  interlibraryLoanCode: string
  borrowingDate: string
  borrowingPeriod: string
  revision: number
  allBranchFlag: boolean
}

export function UpdateDefaultParameterInterLibraryLoanRequestToJSON(
  value: UpdateDefaultParameterInterLibraryLoanRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    material_format_code:
      value.materialFormatCode !== '' ? value.materialFormatCode : undefined,
    holding_branch_code:
      value.holdingBranchCode !== '' ? value.holdingBranchCode : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    interlibrary_loan_code:
      value.interlibraryLoanCode !== ''
        ? value.interlibraryLoanCode
        : undefined,
    borrowing_date:
      value.borrowingDate !== '' ? value.borrowingDate : undefined,
    borrowing_period:
      value.borrowingPeriod !== '' ? value.borrowingPeriod : undefined,
    revision: value.revision ? value.revision : undefined,
    all_branch_flag: value.allBranchFlag ?? undefined
  }
}
